<form
  [formGroup]="form"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
  (ngSubmit)="onFormSubmit()"
  #formRef="ngForm"
>
  <!-- Card -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          aria-controls="searchTagField"
        >
          <span class="fs-3">
            {{ 'tagModule.searchTagField' | translate }}</span
          >

          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div *ngIf="!isCollapsed" class="card-body" id="searchTagField">
      <fieldset class="mb-4">
        <legend class="form-label" id="headerLabel"
          >{{ 'general.header' | translate }}
        </legend>

        <div class="row g-2">
          <div class="col-lg-6" *ngIf="availableLanguages['nl']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-nl"
                  attr.aria-label="{{ 'wcag.nl' | translate }}"
                  id="flag-nl-id0"
                  role="img"
                ></span
              ></span>

              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="headerLabel flag-nl-id0"
                formControlName="tagSearchHeaderNl"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['en']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-en"
                  role="img"
                  attr.aria-label="{{ 'wcag.en' | translate }}"
                  id="flat-en-id0"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="headerLabel flag-en-id0"
                formControlName="tagSearchHeaderEn"
              />
            </div>
          </div>

          <div class="col-lg-6" *ngIf="availableLanguages['fr']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-fr"
                  role="img"
                  attr.aria-label="{{ 'wcag.fr' | translate }}"
                  id="flag-fr-id0"
                ></span
              ></span>

              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="headerLabel flag-fr-id0"
                formControlName="tagSearchHeaderFr"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['de']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-de"
                  role="img"
                  attr.aria-label="{{ 'wcag.de' | translate }}"
                  id="flag-de-id0"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="headerLabel flag-de-id0"
                formControlName="tagSearchHeaderDe"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="mb-4">
        <legend class="form-label" id="placeholderLabel"
          >{{ 'general.placeholder' | translate }}
        </legend>

        <div class="row g-2">
          <div class="col-lg-6" *ngIf="availableLanguages['nl']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-nl"
                  role="img"
                  attr.aria-label="{{ 'wcag.nl' | translate }}"
                  id="flag-nl-id1"
                ></span
              ></span>

              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="placeholderLabel flag-nl-id1"
                formControlName="tagSearchPlaceholderNl"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['en']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-en"
                  role="img"
                  attr.aria-label="{{ 'wcag.en' | translate }}"
                  id="flag-en-id1"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="placeholderLabel flag-en-id1"
                formControlName="tagSearchPlaceholderEn"
              />
            </div>
          </div>

          <div class="col-lg-6" *ngIf="availableLanguages['fr']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-fr"
                  role="img"
                  attr.aria-label="{{ 'wcag.fr' | translate }}"
                  id="flag-fr-id1"
                ></span
              ></span>

              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="placeholderLabel flag-fr-id1"
                formControlName="tagSearchPlaceholderFr"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['de']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-de"
                  role="img"
                  attr.aria-label="{{ 'wcag.de' | translate }}"
                  id="flag-de-id1"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="placeholderLabel flag-de-id1"
                formControlName="tagSearchPlaceholderDe"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <div class="form-footer">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
</form>
